import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostUpdateJackpot = (params, setOpenModalSuccess, setOpenModalError) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_UPDATE_JACKPOT
            });
            setOpenModalSuccess(true);
        } catch (error) {
            //todo доделать catch 
            setOpenModalError(true)
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateJackpot as SetPostUpdateJackpot
}